import styled from 'styled-components';

import { ContentWrapper as AcceptTermsAndConditionsContentWrapper } from '../../accept_terms_and_conditions/index.styles';

export {
  ButtonWrapper,
  Footer,
  ScrollContainer,
  Wrapper,
} from '../../accept_terms_and_conditions/index.styles';

export const ContentWrapper = styled(AcceptTermsAndConditionsContentWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--background);
  text-align: center;
`;

export const ImageWrapper = styled.div`
  margin: 0;
  margin-top: 48px;
  width: 75px;
  height: 75px;
  position: relative;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ImagePlaceholder = styled.img`
  width: 75px;
  height: 75px;
  object-fit: contain;
`;

export const CheckWrapper = styled.div`
  width: 28px;
  height: 28px;
  position: absolute;
  top: 0;
  right: 0;
  padding: 2px;
  background: #1f7d6b;
  border-radius: var(--border-radius-round);
  color: var(--white);
`;

export const Name = styled.p`
  margin: 0;
  margin-top: 16px;
  font-family: Butler, serif;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  text-transform: lowercase;
`;

export const Price = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
  gap: 4px;
  white-space: pre;
`;

export const Amount = styled.span`
  font-family: Butler, serif;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  text-transform: lowercase;
`;

export const Icon = styled.img`
  width: 24px;
  height: 31px;
  object-fit: contain;
`;

export const Description = styled.p`
  margin: 0;
  margin-top: 64px;
  font-family: Butler, serif;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  text-transform: lowercase;
  white-space: pre-wrap;
`;

export const Hint = styled.p`
  margin: 0;
  margin-top: 24px;
`;

export const ButtonAndRoadblockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;
